export const OPEN_JOB_CHECK_CALLABLE = 'checkIfAssignmentInviteStillAvailable';

export const OPEN_JOB_ACCEPT_CALLABLE = 'acceptAssignmentInvite';

export type OpenJobAssignmentPayload =
    | {
          jobId: string;
          techId: string;
          regionId: string;
          inviteToken?: string;
      }
    | {
          regionId: string;
          jobId: string;
          inviteToken: string;
      };

/**
 * Legacy /open-jobs/:regionId/:techId/:jobId sends techId (and inviteToken when the query has one).
 * Token-only SMS /open-jobs/:regionId/:jobId?inviteToken= omits techId. The gen2 accept reads the tech
 * from the token and still requires a signed-in caller.
 */
export function openJobAssignmentPayload(
    regionId: string | null,
    jobId: string | null,
    techId: string | null,
    inviteToken: string,
): OpenJobAssignmentPayload | null {
    if (!regionId || !jobId) return null;
    if (techId) {
        return inviteToken ? { jobId, techId, regionId, inviteToken } : { jobId, techId, regionId };
    }
    if (!inviteToken) return null;
    return { regionId, jobId, inviteToken };
}

/** /open-jobs/{regionId}/{jobId} or /open-jobs/{regionId}/{techId}/{jobId}. */
export function isOpenJobReturnPath(pathname: string): boolean {
    if (typeof pathname !== 'string' || !pathname.startsWith('/open-jobs/')) return false;
    const parts = pathname.split('/');
    if (parts.length !== 4 && parts.length !== 5) return false;
    if (parts[0] !== '' || parts[1] !== 'open-jobs') return false;
    return parts.slice(2).every((part) => /^[A-Za-z0-9_-]+$/.test(part));
}

export function openJobLoginLocation(
    pathname: string,
    search: string,
):
    | '/login'
    | {
          pathname: '/login';
          state: { from: { pathname: string; search: string; hash: string } };
      } {
    if (!isOpenJobReturnPath(pathname)) return '/login';
    return {
        pathname: '/login',
        state: {
            from: {
                pathname,
                search: typeof search === 'string' ? search : '',
                hash: '',
            },
        },
    };
}
